import { Box, HStack, Heading, Text } from '@chakra-ui/react';

import { HiOutlineEmojiSad } from 'react-icons/hi';
import React from 'react';

type emptyProps = {
    title?: string;
    description?: string;
};

export function EmptyTable(props: emptyProps) {
    const { title, description } = props;

    return (
        <Box textAlign="center" py={10} px={6}>
            <HStack justify={'center'}>
                <HiOutlineEmojiSad color='#757575' style={{ width: 70, height: 70, justifySelf: 'center' }} />
            </HStack>
            <Heading color={'#757575'} as="h2" size="lg" mt={4} mb={2}>
                {title}
            </Heading>
            <Text color={'gray.500'}>
                {description}
            </Text>
        </Box>
    );
}